/**
 * Test IDs for QA automation.
 */
export const testIds = {
  tractorInputAutocomplete: "tractor-input-autocomplete",
  tractorInputAutocompleteInput: "tractor-input-autocomplete-input",
  tractorInputAutocompleteOption: "tractor-input-autocomplete-option",
  tractorInputAutocompleteTag: "tractor-input-autocomplete-tag",
} as const;
